import { useContext } from 'react';
import { BaseContextType } from '#base/contexts/BaseContextType';
import { BaseContext } from '#base/contexts/BaseContext';

const useBaseContext = () => useContext<BaseContextType>(BaseContext);

export { useBaseContext };
